require('/ui/components/table/controls/tablecontrols.module.scss.module.css');

export const container = "_container_1hbg9_1";
export const leftControls = "_left-controls_1hbg9_1";
export const rightControls = "_right-controls_1hbg9_1";
export const bottomControls = "_bottomControls_1hbg9_1";
